import { User } from "../../common/resources/user";
import { InventoryItemLocation } from "../../inventory/resources/inventory-item-location";
import { Material } from "../../order/resources/material";
import { Paint } from "../../order/resources/paint";
import { PurchasedItem } from "../../order/resources/purchased-item";
import { Station } from "../../order/resources/station";
import { WorkOrder } from "../../planning/resources/work-order";
import { MaterialBid } from "./materialBid";
import { PurchaseOrderLineItem } from "./purchaseOrder";
import { Requisition } from "./requisition";

export enum PurchasingSheetValidityLevel {
  REQUISITION = -1,
  ESTIMATED = 0,
  PREPLANNED = 1,
  FULLY_PLANNED = 2,
  ALL_SCHEDULED = 3
}

export function getValidityClass(validity: number) {
  switch (validity) {
    case -1:
      // REQUISITION
      return 'bg-info text-white';
    case 0:
      // ESTIMATED
      return 'bg-danger text-white';
    case 1:
      // PREPLANNED
      return 'bg-warning text-dark';
    case 2:
      // FULLY_PLANNED
      return 'bg-success text-white';
    case 3:
      // ALL_SCHEDULED
      return 'bg-info text-white';
    default:
      break;
  }
}

export function getValidityName(validity: number) {
  switch (validity) {
    case -1:
      // REQUISITION
      return 'Requisition';
    case 0:
      // ESTIMATED
      return 'Estimated';
    case 1:
      // PREPLANNED
      return 'Preplanned';
    case 2:
      // FULLY_PLANNED
      return 'Fully Planned';
    case 3:
      // ALL_SCHEDULED
      return 'Fully Scheduled';
    default:
      break;
  }
}

export function getValidityTooltip(validity: number) {
  switch (validity) {
    case 0:
      // ESTIMATED
      return 'Prerequisite comes from an estimate. Information should be taken with a grain of salt, especially for raw material.';
    case 1:
      // PREPLANNED
      return 'Prerequisite comes from preplanning. The required item should be accurate, but the due date may change for better or worse.';
    case 2:
      // FULLY_PLANNED
      return 'Prerequisite comes from a fully-planned workflow. All information should be accurate barring administrative decisions.';
    case 3:
      // ALL_SCHEDULED
      return 'Prerequisite comes from a fully-scheduled workflow. All information should be accurate.';
    default:
      break;
  }
}


export interface PurchasingSheetItemAssignment
{
  purchasingSheetItemAssignmentId: string;
  purchasingSheetItemId: string;
  qtyAssigned: number;

  dateAssigned: Date;
  assigningUserId: string;
  assigningUser: User;

  type: number;

  purchaseOrderLineItemId: string;
  purchaseOrderLineItem: PurchaseOrderLineItem;
  inventoryItemLocationId: string;
  inventoryItemLocation: InventoryItemLocation;
}
export interface PurchasingSheet
{
  purchasingSheetId: string;
  workOrderId?: string;
  validity: PurchasingSheetValidityLevel;
  purchasingSheetItems: PurchasingSheetItem[];
  workOrder?: WorkOrder;
  isDeleted: boolean;
  requisitionId?: string;
  requisition?: Requisition;
}

export interface PurchasingSheetItem {
  purchasingSheetItemId: string;
  purchasingSheetId: string;
  qty: number;
  perJob: boolean;
  amortized: boolean;
  dueDate?: Date;

  materialNeedId?: string;
  stationId?: string;
  workflowStepId?: string;
  paintId?: string;
  purchasedItemId?: string;

  paintUnits: string;


  materialNeed: MaterialNeed;
  station: Station;
  paint: Paint;
  purchasedItem: PurchasedItem;
  
  purchasingSheet: PurchasingSheet;
  isDeleted: boolean;

  readonly name: string;

  assignments: PurchasingSheetItemAssignment[];

  materialBid: MaterialBid;
}

export interface MaterialNeed {
  materialNeedId: string;
  materialNeedMaterials: {
    isPrimary: boolean;
    material: Material;
  }[]

  partsPerBlank: number;
  blanksPerMaterialUnit: number;
}